// extracted by mini-css-extract-plugin
export default {"root":"ForeignAgentKrik_root__BDXjr","dark":"ForeignAgentKrik_dark__VbzNT","text":"ForeignAgentKrik_text__B1t9k","inline":"ForeignAgentKrik_inline__MSg9k"};